<!-- <div class="modal-dialog"> -->
<!-- <div class="dialog-title" (click)="clickclose()"> -->
<mat-dialog-actions>
    <span class="closebuttonspan" mat-dialog-close mat-icon-button aria-label="close dialog" (click)="clickclose()">
        <i class="closebutton fa-solid fa-circle-xmark" (click)="clickclose()"></i>

    </span>
</mat-dialog-actions>
<!-- </div> -->

<mat-dialog-content class="mat-dialog-content">
    <div class="row timename">
        <div class="col-4"><span class="begtime">{{data.entertainmentitem.aiibegtime | timepipe}}</span></div>
        <div class="col-8">
            <div class="locationanddeck">
                <span class="location">{{data.entertainmentitem.slnName}}</span>
                <span> | </span>
                <span class="deck">{{data.entertainmentitem.dplDeck}}</span>

            </div>
        </div>

    </div>
    <div class=""><span class="actname">{{data.entertainmentitem.aiiActivityName}}</span></div>
    <div class="actdesc">
        {{data.entertainmentitem.aiiActivityDesc}}
    </div>

    <app-longgoldbar-dialog></app-longgoldbar-dialog>
    <div class="entertainername">{{data.entertainmentitem.entName}}</div>
    <div class="entertainer ">
        <div class="entertainerpic float-end " *ngIf="data.entertainmentitem.entImage!=null">
            <img src="{{imagepath}}entbioimages/{{data.entertainmentitem.entImage}}" class="img-fluid" alt=""
                onerror="this.style.display='none'">
        </div>

        <div class="entertainerbio ">{{data.entertainmentitem.entBioText}}</div>
    </div>

</mat-dialog-content>

<!-- </div> -->